import { InformationCircleIcon } from "@heroicons/react/24/outline";

const ScrollingInfoBanner = ({ services, portfolioItems, profileCompletion = 0 }) => {
  // Check if builder has uploaded services or portfolio
  const hasServices = services && services.length > 0;
  const hasPortfolio = portfolioItems && portfolioItems.length > 0;
  const isProfileComplete = profileCompletion >= 96;

  // If all conditions are met, don't show anything
  if (hasServices && hasPortfolio && isProfileComplete) {
    return null;
  }

  // Determine the missing items for the message
  let missingItems = [];
  if (!hasServices) missingItems.push("upload your services");

  // Only add portfolio if we haven't added too many things already, but generally we want to show all missing
  if (!hasPortfolio) missingItems.push("portfolio");

  if (!isProfileComplete) missingItems.push("complete 96% of your profile");

  // Construct the message
  let actionText = "";
  if (missingItems.length === 1) {
    actionText = missingItems[0];
  } else if (missingItems.length === 2) {
    actionText = `${missingItems[0]} and ${missingItems[1]}`;
  } else if (missingItems.length >= 3) {
    // If more than 2 items, join with commas and add 'and' for the last item
    const lastItem = missingItems.pop();
    actionText = `${missingItems.join(", ")} and ${lastItem}`;
  }

  // Capitalize the first letter
  if (actionText) {
    actionText = actionText.charAt(0).toUpperCase() + actionText.slice(1);
  }

  const message = `${actionText} in your dashboard to Complete your Profile`;

  return (
    <div className="w-full bg-red-50 border-b border-red-200">
      <div className="px-4 py-3 flex items-center justify-center gap-3">
        <InformationCircleIcon className="w-5 h-5 text-red-600 flex-shrink-0" />
        <p className="text-sm text-red-600 font-medium text-center">
          {message}
        </p>
      </div>
    </div>
  );
};

export default ScrollingInfoBanner;